<template>
  <div class="template-wrap prod-tile-tooltip-template">
    <div class="subject">
      <span>{{ data.subject }}</span>

      <gc-status-chip
        :status="data.FriendlyStatus"
        v-if="data.FriendlyStatus"
        :data="data"
        :customBackGroundColor="customBackGroundColor"
      />
    </div>
    <div class="description">
      <span>{{ data.ProductCode }}</span>
      <span>{{ data.ProductDescription1 }} </span>
    </div>

    <!-- Products Section -->
    <div
      class="products-section"
      v-if="data.SalesOrderProducts && data.SalesOrderProducts.length > 0"
    >
      <div class="products-header">Products</div>
      <div
        class="product-item"
        v-for="(product, index) in data.SalesOrderProducts"
        :key="index"
      >
        <div class="product-header-row">
          <div class="product-code">{{ product.ProductCode }}</div>
          <div class="quantity-label">Quantity</div>
        </div>
        <div class="product-detail-row">
          <div class="product-description">
            {{ product.ProductDescription1 }}
          </div>
          <div class="quantity-value">
            {{ getFormattedQty(product.StockUMQty) }} ({{ product.StockUM }})
          </div>
        </div>
      </div>
    </div>

    <div class="data">
      <div class="left">
        <span>
          {{ data.WOType === "Maintenance" ? "Duration" : "Planned" }}
        </span>
        <span>
          {{ getPlanned(data) }}
        </span>
      </div>
      <div class="right">
        <!-- <span>Actual</span>
        <span>
          {{ getFormattedQty(data.RequiredQty) }}
          ({{ data.StockUM }})
        </span> -->
      </div>
    </div>

    <div class="data">
      <div class="left">
        <span>Start</span>
        <span> {{ getFormattedDate(data.StartDate) }} </span>
      </div>
      <div class="right">
        <span>End</span>
        <span> {{ getFormattedDate(data.EndDate) }} </span>
      </div>
    </div>
  </div>
</template>
<script>
import { formatNumber } from "devextreme/localization";
import { getMaintenanceDuration } from "../../../_helpers/calendar/helpers";
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormattedQty(value) {
      return formatNumber(value, "##,###,###,###,##0.00");
    },
    getFormattedDate(value) {
      if (value)
        return (
          new Date(value.toISOString().replace("Z", "")).toShortDateString() +
          " - " +
          new Date(value.toISOString().replace("Z", "")).toShortTimeString()
        );
      else return "";
    },
    customBackGroundColor(data) {
      if (data.WOType === "Maintenance") {
        return "#808080";
      }
      return undefined;
    },

    /*
     * Get Planned or Duration based on WOType
     * @param data
     * @returns {string}
     */
    getPlanned(data) {
      if (data) {
        if (data.WOType === "Maintenance") {
          return getMaintenanceDuration(data.StartDate, data.EndDate);
        } else if (data.RequiredQty && data.StockUM) {
          return `${this.getFormattedQty(data.RequiredQty)} ${data.StockUM}`;
        } else if (data.RequiredQty) {
          return `${this.getFormattedQty(data.RequiredQty)}`;
        } else if (data.StockUM) {
          return `${data.StockUM}`;
        }
      }

      return "";
    },
  },
};
</script>

<style lang="scss">
.e-tooltip-wrap {
  background-color: white !important;
  width: auto;
  color: black !important;
  padding: 5px;
  .prod-tile-tooltip-template {
    color: black !important;
    width: auto;
    display: flex;
    flex-direction: column;
    .subject {
      display: flex;
      justify-content: space-between;
      font-size: 14px;

      > span:first-child {
        font-family: Roboto;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0%;
        color: var(--Colors-Text-text-placeholder, #667085);
      }
    }

    .subject span:last-child {
      font-size: 10px;
    }

    .description {
      padding-top: 5px;
      display: flex;
      justify-content: space-between;

      > span:first-child {
        font-family: Inter;
        font-weight: 600;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0%;
        color: var(--colors-text-text-primary-900, #101828);
      }

      > span:last-child {
        font-family: Roboto;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0%;
        text-align: right;
        color: var(--Colors-Text-text-placeholder, #667085);
        width: 150px;
      }
    }

    // Products Section Styles
    .products-section {
      padding: 10px 0px;
      margin: 5px 0px;
      border-top: 1px solid #e5e7eb;
      border-bottom: 1px solid #e5e7eb;

      .products-header {
        font-family: Roboto;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: var(--Colors-Text-text-placeholder, #667085);
        margin-bottom: 8px;
      }

      .product-item {
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }

        .product-header-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 2px;

          .product-code {
            font-family: Roboto;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            color: var(--Colors-Text-text-placeholder, #667085);
          }

          .quantity-label {
            font-family: Roboto;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            color: var(--Colors-Text-text-placeholder, #667085);
            text-align: right;
          }
        }

        .product-detail-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 10px;

          .product-description {
            font-family: Roboto;
            font-weight: 700;
            font-size: 12px;
            line-height: 18px;
            color: var(--colors-text-text-primary-900, #101828);
            flex: 1;
            word-wrap: break-word;
            white-space: normal;
          }

          .quantity-value {
            font-family: Roboto;
            font-weight: 500;
            font-size: 12px;
            line-height: 18px;
            color: var(--colors-text-text-secondary-700, #323842);
            text-align: right;
            white-space: nowrap;
          }
        }
      }
    }

    .data {
      padding-top: 5px;
      display: flex;
      justify-content: space-between;

      // .actual {
      //   padding-left: 25px;
      // }

      > div {
        display: flex;
        flex-direction: column;
        padding: 0;

        > span:first-child {
          font-family: Roboto;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          letter-spacing: 0%;
          color: var(--Colors-Text-text-placeholder, #667085);
        }

        > span:last-child {
          font-family: Roboto;
          font-weight: 500;
          font-size: 12px;
          line-height: 18px;
          letter-spacing: 0%;
          color: var(--colors-text-text-secondary-700, #323842);
        }
      }

      .right {
        text-align: right;

        > span {
          padding-left: 20px;
        }
      }
    }
  }
}
</style>
